import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { BaseReactComponent, Form, FormElement, FormSubmitButton, FormValidator, SelectControl } from "../../utils/form";
import { Table, Image, Row, Col, Tabs, Tab, Button, Modal } from "react-bootstrap";
import ComponentHeader from "../common/ComponentHeader";
import { getDetaisContentEventApi, getDetaisCustomerApi, getUserTrackingApi } from "./Api";
import closeIcon from '../../assets/images/greay-cancel-icon.svg';
import moment from "moment";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { ALT_THUMBNAIL, API_LIMIT, MAX_LIMIT, START_PAGE, durationObj } from "../../utils/Constant";
import { getCommonApi, postAuthCommonApi } from "../content/Api";
import Pagination from "../../utils/commonComponent/Pagination";
import { useNavigate, useLocation } from "react-router-dom";
import { withRouter } from "../../utils/hoc/withRouter";
class ViewSsoUser extends BaseReactComponent {
  constructor(props) {
    super(props);
    const { params } = props.match;
    const ssoPartnerId = params.ssoPartnerId;
    const ssoData = this.props?.location?.state?.id;
    const userType = this.props?.location?.state?.type;
    console.log(props)

    this.state = {
      params,
      detailsData: "",
      activeTab: '',
      // data: ssoData,
      type: userType,
      ssoId: ssoData,
      ssoPartnerId
    };
    // this.handleChildAction = this.handleChildAction.bind(this);
  }

  // handleChildAction() {
  //     getDetaisCustomerApi("customer", this);
  // }
  // handleChildAction() {
  //   getDetaisContentEventApi("/sso/web-user/details", this);
  // }

  componentDidMount = () => {
    const userType = this.state.type || sessionStorage.getItem('type');

    getDetaisContentEventApi(
      `${userType === "admin" || userType === "admin-web-user"
        ? "/sso/web-user/admin/details"
        : "/sso/web-user/details"
      }`,
      this
    );

    // this.props.getUserTrackingApi(this);
    this.props.history({ search: 'tab=details' })
    console.log(this, "this usersss")



  }
  // componentDidUpdate(prevProps) {
  //   if (this.props.location.search !== prevProps.location.search) {

  //     const newType = sessionStorage.getItem("type");
  //     this.setState({ type: newType })

  //   }
  // }
  componentWillUnmount() {
    // sessioStorage.removeItem("detail");
    sessionStorage.removeItem("type");

  }



  detailsTab = (data) => {

    return (
      <div className="view-details-content">
        <h3 className="inter-regular f-s-14 grey-2">
          Details
        </h3>
        <div className="line2"></div>
        <Table className="custom-table">
          <Row>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">First Name</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.firstName} </h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Last Name</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.lastName} </h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Email</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.emailAddress || "NA"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">Phone no.</h4>
                <h3 className="inter-semibold f-s-14 ">{data?.mobileNumber || "Na"}</h3>
              </div>
            </Col>


            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">
                  Company Name
                </h4>
                <h3 className="inter-semibold f-s-14 ">{data?.companyName || "Na"}</h3>
              </div>
            </Col>
            <Col sm={3} xs={12}>
              <div className="detail">
                <h4 className="inter-semibold grey-2 ">
                  ARN Number
                </h4>
                <h3 className="inter-semibold f-s-14 ">{data?.arnNumber || "Na"}</h3>
              </div>
            </Col>
          </Row>
        </Table>
      </div>
    )
  }




  returnDate(timestamp) {
    const date = new Date(timestamp);
    const formattedDate = date.toISOString().split('T')[0];
    return formattedDate;
  }

  render() {
    const { data, activeTab, params, ssoId, ssoPartnerId } = this.state;
    const userType = this.state.type || sessionStorage.getItem('type');

    const { trackingList, totalPages, currentPage } = this.props.trackingState;
    // console.log(data)
    return (
      <section className="user-section">
        <div className="view-details-wrapper">
          <ComponentHeader
            title={`Customer Details`}
            isBackArrow={true}
            isReturn={
              userType === "admin"
                ? `/partner/view-users/${ssoPartnerId}`
                : userType === "admin-web-user"
                  ? "/customers"
                  : "/sso/web-user"}


          />
          <div className="view-details">
            <Tabs
              defaultActiveKey={'Details'}
              onSelect={(d) => { this.setState({ activeTab: d }); this.props.history({ search: 'tab=' + d }) }}
              className="inter-regular f-s-16 lh-22 user-details-tabs"
              id=""
            >
              <Tab eventKey={'Details'} title={'Details'}>
                {this.detailsTab(data)}
              </Tab>

              <Tab eventKey={'Activity'} title={'Activity'}>
                <MyActivity data={data} />

              </Tab>
              <Tab eventKey={'Subscription'} title={'Subscription'}>
                <CustomerSubscriptionWithRouter data={data?.userSubscription} handleAction={this.handleChildAction} id={params.adsID} />
              </Tab>
              <Tab eventKey={'userEvents'} title={'User Events'}>
                {/* {data?.userEvents?.length > 0 ? data?.userEvents?.map((item => this.detailsTab1(item))) : <h3 className="inter-regular f-s-24 lh-32 py-5 text-center"> There is not event! </h3>} */}
                <MyEvents data={data?.userEvents} />
              </Tab>



            </Tabs>

          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({ trackingState: state.SsoContentEventState });
const mapDispatchToProps = {
  // getPosts: fetchPosts
  // getUserTrackingApi

};
ViewSsoUser.propTypes = {
  // getPosts: PropTypes.func
  location: PropTypes.object.isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewSsoUser)));


function MyActivity({ data }) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [activityType, setActivityType] = useState('Liked');
  const [activityData, setActivityData] = useState([]);
  const [activityCount, setActivityCount] = useState(0);
  const uniqueTypes = ['Cobrand', 'Downloaded', 'Liked', 'Shared']; // List of all unique types
  const [currentPage, setCurrentPage] = useState(1);

  const TabsNames = [{ name: 'Downloads', type: "Downloaded" }, { name: "Co-Brands", type: "Cobrand" }, { name: "Likes", type: "Liked" }, { name: "Shares", type: "Shared" }, { name: "Recent Search", type: "Search" },]
  useEffect(() => {
    const fetchData = async () => {
    const userId = data?.id
    const Type = (TabsNames.find((ele => ele.name === activityType)))?.type || 'Downloaded';
    if (userId) {
      const res = await getCommonApi(`sso/web-user/tracking?userId=${userId}&type=${activityType}&pageNumber=${params.get('p') || START_PAGE}&pageSize=${API_LIMIT}`);
      // console.log(res)

      setActivityData(res.data.data?.list)
      setActivityCount(res?.data?.data?.totalCount)

    }
  };
  fetchData();
  }, [activityType, data])
  return (
    <div className="activity-tabs-section">
      <Tabs
        defaultActiveKey={'Liked'}
        onSelect={(data) => { setActivityType(data) }}
        className="inter-regular f-s-16 lh-22 user-details-tabs bg-ECE"
        id=""
      >

        {uniqueTypes.map((type) => {
          const filteredData = activityData?.filter(item => item.type === type);

          return (
            <Tab eventKey={type} title={type} key={type}>
              {filteredData?.length > 0 ? (
                <div className="commom-table-wrapper">
                  <CustomTable
                    data={filteredData || []}
                    columns={[
                      {
                        width: 300,
                        title: "Title",
                        dataIndex: "tile",
                        className: "name",
                        isCell: true,
                        render:(text, rowData, dataKey) => {
                            return rowData?.tile;
                        },
                      },

                      {
                        width: 300,
                        title: "Content Type",
                        dataIndex: "contentType",
                        className: "name",
                        isCell: true,
                        render:(text, rowData, dataKey) => {
                            return rowData?.contentType;
                        },
                      },
                      // {
                      //     width: 300,
                      //     title: "Thumbnail Image",
                      //     dataIndex: "thumbnail",
                      //     className: "",
                      //     isCell: true,
                      //     render:(text, rowData, dataKey) => {
                      //         if (dataKey === "thumbnail") {
                      //             return rowData.thumbnail ? (
                      //                 <Image
                      //                     src={rowData.thumbnail}
                      //                     className="table-img"
                      //                     alt={ALT_THUMBNAIL}
                      //                 />
                      //             ) : (
                      //                 "NA"
                      //             );
                      //         }
                      //     },
                      // },

                    ]}
                    message="No data found" // For Pagination
                    history={navigate}
                    location={location}
                    total={Math.ceil(activityCount / API_LIMIT)}
                    currentPage={parseInt(params.get('p')) || START_PAGE}
                  />

                </div>
              ) : (
                <h1 className="inter-regular f-s-24 lh-32 text-center py-4 w-100">
                  No data...
                </h1>
              )}
            </Tab>
          );
        })}



      </Tabs>
    </div>
  )
}
class CustomerSubscription extends BaseReactComponent {
  constructor(props) {
    super(props);
    // console.log(props)
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      activeHistory: false,
      show: false,
      plan: '',
      offerLine: '',
      billingFrequency: '',
      plansData: [],
      subPremiumPlan: [],
      subPremiumPlanVariation: [],

      subscriptionDetails: [],
      userDetails: JSON.parse(localStorage.getItem('finAdmin'))

    };
  }
  handleClick() {
    this.props.handleAction();
  }






  render() {
    // const { show, plansData, subPremiumPlan, subPremiumPlanVariation, offerLine, plan } = this.state;
    const { data } = this.props;

    console.log("Data of tablle :-", data)

    return (
      <div className="activity-tabs-section">
        {/* =============== modal============== */}

        {/* =============== modal end============== */}

        <div className="commom-table-wrapper">
          <CustomTable
            data={data || []}
            columns={[
              {
                width: 150,
                title: "Name",
                dataIndex: "premiumPlan",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.premiumPlan;
                },
              },
              {
                width: 150,
                title: "Plan Name",
                dataIndex: "subPremiumPlan",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.subPremiumPlan;
                },
              },
              {
                width: 150,
                title: "Variation",
                dataIndex: "subPremiumPlanVariation",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.subPremiumPlanVariation;
                },
              },



              {
                width: 90,
                title: "isTopup",
                dataIndex: "isTopup",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.isTopup ? "Yes" : "No";
                },
              },
              {
                width: 170,
                title: "Is Paid",
                dataIndex: "Paid",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.isPaid ? "Yes" : 'No';
                },
              },
              {
                width: 170,
                title: "Is Active",
                dataIndex: "Active",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.isActive ? "Yes" : 'No';
                },
              },
              {
                width: 170,
                title: "Start Date",
                dataIndex: "startDate",
                className: "startDate",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return moment(rowData?.startDate).format('lll');
                },
              },
              {
                width: 170,
                title: "End Date",
                dataIndex: "endDate",
                className: "endDate",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return moment(rowData?.endDate).format('lll');
                },
              },
              {
                width: 200,
                title: "Action",
                dataIndex: "endDate",
                className: "endDate",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return <Button onClick={() => this.setState({ activeHistory: true, subscriptionDetails: rowData })} className="primary-btn" alt=""> View Details </Button>
                },
              },

            ]}
          />
        </div>
        <Modal className="subscription-details-modal" show={this.state.activeHistory} onHide={() => this.setState({ activeHistory: false })}>

          <Modal.Body className="sub-modal-body-modal py-5">
            <Image src={closeIcon} onClick={() => this.setState({ activeHistory: false })} alt="canle icon" className="close-btn pointer" />
            <h4 className="inter-regular  black-242 w-100 mb-3 text-start primary">Invoices</h4>
            <table className="w-100 invoice-table-frame">
              <thead>
                <tr className="invoice-header-row">
                  <th className=" inter-regular ">Id</th>
                  {/* <th className=" inter-regular ">Plan</th> */}
                  <th className=" inter-regular ">Date</th>
                  <th className=" inter-regular ">Amount</th>
                  <th className=" inter-regular ">Status</th>
                  <th className=" inter-regular ">Download</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.subscriptionDetails?.userBillingPlan?.map((ele, i) => {
                    return (
                      <tr className="invoice-body-row">
                        <td className=" inter-regular ">{i + 1}</td>
                        {/* <td className=" inter-regular ">{i + 1}</td> */}
                        <td className=" inter-regular ">{moment(ele?.startDate).format('lll')}</td>
                        <td className=" inter-regular ">{ele.amountPaid}</td>
                        <td className=" inter-regular ">{ele.isActive ? 'Yes' : 'No'}</td>
                        <td className=" inter-regular "><a href={ele?.invoicePdfPath} target="_blank" className=" ponter">Download</a></td>
                      </tr>
                    )
                  })
                }

              </tbody>
            </table>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
const CustomerSubscriptionWithRouter = withRouter(CustomerSubscription);

function MyEvents({ data }) {

  return (
    <div className="commom-table-wrapper">
      <CustomTable
        data={data || []}
        columns={[
          {
            width: 150,
            title: "Name",
            dataIndex: "name",
            className: "name",
            isCell: true,
            render:(text, rowData, dataKey) => {
                return rowData?.event?.name;
            },
          },
          {
            width: 150,
            title: "Event Format",
            dataIndex: "eventFormat",
            className: "name",
            isCell: true,
            render:(text, rowData, dataKey) => {
                return rowData?.event?.eventFormat;
            },
          },
          {
            width: 150,
            title: "Event Type",
            dataIndex: "eventType",
            className: "name",
            isCell: true,
            render:(text, rowData, dataKey) => {
                return rowData?.event?.eventType;
            },
          },

          {
            width: 170,
            title: "Is Paid",
            dataIndex: "Paid",
            className: "name",
            isCell: true,
            render:(text, rowData, dataKey) => {
                return rowData?.isPaid ? "Yes" : 'No';
            },
          },

          {
            width: 200,
            title: "Start Date",
            dataIndex: "startDate",
            className: "startDate",
            isCell: true,
            render:(text, rowData, dataKey) => {
                return moment(rowData?.event?.startDate).format('lll');
            },
          },
          {
            width: 200,
            title: "End Date",
            dataIndex: "endDate",
            className: "endDate",
            isCell: true,
            render:(text, rowData, dataKey) => {
                return moment(rowData?.event?.endDate).format('lll');
            },
          },


        ]}
      />
    </div>

  )

}



